<template>
  <v-sheet>
    <v-card-text>
      <h5 class="font-weight-bold mb-1 text-h5">
        Account Recovery
      </h5>

      <v-scale-transition
        group
        hide-on-leave
      >
        <div
          v-if="isRequestScreenVisible"
          key="request-screen"
        >
          <p
            class="py-3 text--secondary"
          >
            In order to recover your account and set a new password, a second-factor will be needed in order to verify that the account belongs to you.
          </p>

          <v-form
            v-model="validForm"
            @submit.prevent
          >
            <v-text-field
              v-model="form.login"
              outlined
              label="Username"
              prepend-inner-icon="mdi-account"
              :disabled="isSubmitting"
              :rules="rules.login"
            />

            <v-text-field
              v-model="form.email"
              outlined
              label="E-mail Address"
              prepend-inner-icon="mdi-email"
              :disabled="isSubmitting"
              :rules="rules.email"
            />

            <v-row
              align="center"
              class="my-5"
            >
              <v-divider />
              <span class="lighten-3 mx-4 text-caption text-uppercase">Select an Authentication Method</span>
              <v-divider />
            </v-row>

            <div
              class="d-flex mt-3"
            >
              <v-btn
                class="mb-3"
                block
                text
                outlined
                :disabled="!validForm"
                :loading="isSubmittingMagicLink"
                @click="submitAccountRecovery('magiclink')"
              >
                <v-icon left>
                  mdi-email-lock
                </v-icon>
                Email me a magic link
              </v-btn>
            </div>
          </v-form>

          <div
            class="d-flex pt-4"
          >
            <v-btn
              text
              @click="closeScreen"
            >
              <v-icon left>
                mdi-arrow-left
              </v-icon>
              Back
            </v-btn>
          </div>
        </div>

        <div
          v-if="isSuccessScreenVisible"
          key="success-screen"
        >
          <p>A Magic Link has been sent to the e-mail address associated with your account.</p>
          <p>Please open that link in this browser, without closing it, in order to finish the recovery process.</p>
          <p>Thank you.</p>
        </div>
      </v-scale-transition>
    </v-card-text>
  </v-sheet>
</template>

<script>
import { mapActions } from 'vuex'

import { USER_NAMESPACE } from '@/store/user'
import { alertHandler } from '@/alertHandler'
import { parseErrorResponseMessage } from '@/utilities/error-responses'
import { rules } from '@/utilities/validation-rules'

const Screens = {
  RequestScreen: 0,
  SuccessScreen: 1,
}

export default {
  name: 'AccountRecovery',

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      currentScreen: Screens.RequestScreen,
      form: {
        email: '',
        login: '',
      },

      isSubmitting: false,
      rules: {
        email: [
          rules.required,
          rules.emailAddress,
        ],

        login: [
          rules.required,
        ],
      },

      strategy: '',
      validForm: false,
    }
  },

  computed: {
    isRequestScreenVisible () {
      return this.currentScreen === Screens.RequestScreen
    },

    isSubmittingMagicLink () {
      return this.isSubmitting && this.strategy === 'magiclink'
    },

    isSuccessScreenVisible () {
      return this.currentScreen === Screens.SuccessScreen
    },
  },

  methods: {
    closeScreen () {
      this.$emit('on-close')
    },

    showRequestScreen () {
      this.isSubmitting = false
      this.currentScreen = Screens.RequestScreen
    },

    showSuccessScreen () {
      this.isSubmitting = false
      this.currentScreen = Screens.SuccessScreen
    },

    submitAccountRecovery (strategy) {
      this.strategy = strategy
      this.isSubmitting = true

      this.requestUserAccountRecovery({
        email: this.form.email,
        login: this.form.login,
        strategy: strategy,
      }).
        then(_ => this.showSuccessScreen()).
        catch(response => {
          this.displayAlert(
            'error',
            parseErrorResponseMessage(response)
          )
          this.showRequestScreen()
        })
    },

    ...mapActions(USER_NAMESPACE, [
      'requestUserAccountRecovery',
    ]),
  },
}
</script>
